// Small helper: resolve a lucide-react icon by string name.
// Used by dynamic content (Departments, Service categories) that store the icon as text.
import * as LucideIcons from "lucide-react";

/**
 * Get the icon component for a given name. Falls back to `fallback`
 * (default: Sparkles) if the name doesn't match any lucide export.
 */
export function getIcon(name, fallback = "Sparkles") {
  const Comp = name && LucideIcons[name];
  if (Comp) return Comp;
  return LucideIcons[fallback] || LucideIcons.Sparkles;
}
